<template>
  <div>
    <div class="list-page">
      <div id="wp_news_w1">
        <ul class="list_top" frag="窗口11" portletmode="simpleList">
          <li class="list_guild" v-for="item in list">
            <!--新闻发布时间-->
            <img src="@/assets/img/dian.jpg" alt="" />
            <a
              @click="handleDetail(item)"
              target="_blank"
              :title="item.articleTitle"
              >{{ item.articleTitle }}</a
            >
            <span>{{ item.createTime | dateFilters }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom-pagination">
      <a-pagination
        v-model="queryParams.pageNum"
        :total="total"
        size="small"
        show-quick-jumper
        :show-total="
          (total) => `每页 ${queryParams.pageSize} 记录 总共 ${total} 记录`
        "
        :item-render="itemRender"
        :defaultPageSize="queryParams.pageSize"
        @change="onChangePagination"
        :showSizeChanger="false"
      />
    </div>
  </div>
</template>

<script>
import { getList, articleDetail } from "@/api/article";
import { dateFormat } from "@/utils";

export default {
  data() {
    return {
      queryParams: {
        pageSize: 15,
        pageNum: 1,
      },
      total: 0,
      list: [],
      articleTypeId: "",
    };
  },
  filters: {
    dateFilters(data) {
      return dateFormat("yyyy-MM-dd", new Date(data));
    },
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(val) {
        if (val.articleTypeId) {
          this.articleTypeId = val.articleTypeId;
          this.getArticleList(val.articleTypeId);
        }
      },
    },
  },
  created() {},
  methods: {
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>上一页</a>;
      } else if (type === "next") {
        return <a>下一页</a>;
      }
      return originalElement;
    },
    async getArticleList(articleTypeId) {
      const { code, data, total } = await getList({
        articleTypeId: this.articleTypeId,
        pageNum: this.queryParams.pageNum, //页码 默认为1
        pageSize: this.queryParams.pageSize, //每页记录数 默认为10
      });
      if (code == 200) {
        this.list = data;
        this.total = total;
      }
    },
    async handleDetail(item) {
      if (item.isOuterChain == 0) {
        //外链
        window.open(item.articleContent);
      } else {
        window.parent.postMessage(
          {
            status: "articleMsg-ok",
            params: {
              artilceId: item.id,
            },
          },
          "*"
        );
        let routeUrl = this.$router.resolve({
          path: "/detail",
          query: {
            artilceId: item.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }

      // this.$router.push({
      //   path: "/detail",
      //   query: {
      //     artilceId: item.id,
      //   },
      // });
    },
    onChangePagination(pageNum, pageSize) {
      this.queryParams.pageNum = pageNum;
      this.getArticleList();
    },
  },
};
</script>

<style lang="scss" scoped>
.list-page {
  width: 875px;
  font-family: "microsoft yahei";
  font-size: 16px;
  color: #333;
  margin: 0px auto;
  padding: 0px;
  ul {
    font-family: "microsoft yahei";
    font-size: 16px;
    color: #333;
    margin: 0px;
    padding: 0px;
    li {
      font-family: "microsoft yahei";
      font-size: 16px;
      color: #333;
      margin: 0px;
      padding: 0px;
      list-style: none;
      position: relative;
      overflow: hidden;
      line-height: 45px;
      border: 1px solid #ebebeb;
      margin-bottom: 15px;
      background-color: #f9f9f9;
      img {
        font-size: 16px;
        color: #333;
        list-style: none;
        line-height: 45px;
        vertical-align: middle;
        outline: none;
        border: 0;
        padding-left: 10px;
        float: left;
        margin-top: 20px;
      }
      a {
        font-family: "microsoft yahei";
        font-size: 16px;
        list-style: none;
        line-height: 45px;
        text-decoration: none !important;
        float: left;
        margin-left: 10px;
        color: #333333;
      }
      span {
        font-family: "microsoft yahei";
        list-style: none;
        line-height: 45px;
        position: absolute;
        font-size: 14px;
        right: 10px;
        color: #999999;
        top: 2px;
      }
    }
  }
}
.bottom-pagination {
  margin: 0px auto;
  padding: 0px;
  width: 875px;
  text-align: right;
  margin-top: 16px;
}
</style>
